<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar
    class="block w-full"
    name="Woordenslang"
    [steps]="snakes().length"
    [progress]="snakeIndex()"
    (click)="showPlus.set(!showPlus())"
  />

  <rid-mechanic-content>
    <!-- title -->
    <rid-mechanic-title [title]="'Sleep een woord om een samengesteld woord te maken'" />

    <!-- assignment -->
    @if (showAssignment()) {
      <div class="absolute grid w-full justify-items-center gap-24" animate.leave="anim-fade-out">
        <!-- words -->
        <div class="flex gap-4" [class.invisible]="!showOptions()" [class.pointer-events-none]="!showOptions()">
          @for (option of assignment().options; track $index) {
            <div class="grid">
              <rid-spacer class="stack-cell">
                <rid-klank-card
                  class="block w-3xs"
                  [klank]="option.word"
                  [class.anim-pop-in]="showOptions()"
                  [style.animation-delay.ms]="showOptions() ? $index * 100 : null"
                  ridSfx="BUBBLE_POP"
                />
              </rid-spacer>

              @if (option.available) {
                <rid-draggable
                  class="stack-cell"
                  (started)="onDragStart($index)"
                  (moved)="onDragMove($event[0], $event[1])"
                  (released)="onDragRelease($event, $index)"
                >
                  <rid-klank-card
                    class="block w-3xs"
                    [klank]="option.word"
                    [disabled]="dragIndex() !== undefined && dragIndex() !== $index"
                    [class.anim-pop-in]="showOptions()"
                    [style.animation-delay.ms]="showOptions() ? $index * 100 : null"
                    ridSfx="BUBBLE_POP"
                  />
                </rid-draggable>
              }
            </div>
          }
        </div>

        <div
          class="justify-self-stretch"
          animate.enter="anim-fade-from-right"
          (animationend)="$event.animationName === 'fade-from-right' ? revealOptions() : undefined"
        >
          <div class="flex justify-center">
            <div
              class="flex gap-4 transition-transform duration-500 ease-in-out"
              [style.transform]="'translateX(-' + snakeTransform() + 'rem)'"
            >
              @for (word of assignment().snake; track $index) {
                <div class="w-3xs">
                  <rid-klank-card
                    [disabled]="showDropZone() ? $index < assignment().snake.length - 1 : $index < assignment().snake.length - 2"
                    [klank]="word"
                  />
                </div>
              }
              @if (showPlus()) {
                <div class="font-family-din content-center text-4xl text-white select-none">+</div>
              }
              @if (showDropZone()) {
                <rid-drop-zone
                  #dropZone
                  class="block w-3xs rounded-sm border-4 border-dotted border-white bg-white/30 p-4 text-4xl select-none"
                />
              }
            </div>
          </div>
        </div>
      </div>
    }
    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
